import React from 'react';

export const Navigation = () => {
  const scrollToForm = (e) => {
    e.preventDefault();
    const formCard = document.getElementById('form-card');
    if (formCard) {
      formCard.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // const scrollToSection = (e) => {
  //   e.preventDefault();
  //   const researchSection = document.querySelector('.research-section');
  //   if (researchSection) {
  //     researchSection.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  return (
    <nav>
      <div className="nav-inner">
        <button className="nav-logo" onClick={(e) => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          AIFirst<span>CHRO</span>
        </button>
        <div className="nav-right">
          {/* <button className="nav-link" onClick={scrollToSection}>Your Journey</button> */}
          <button className="nav-cta" onClick={scrollToForm}>Request Your Copy</button>
        </div>
      </div>
    </nav>
  );
};
